var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exercises-form-switcher"},[_vm._l((_vm.buttons),function(button,index){return [_c('div',_vm._g({key:index,staticClass:"item",class:button.classes},button.events),[_vm._v(" "+_vm._s(button.label)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }